import { CdkNoDataRow } from "@angular/cdk/table";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ReportTokenErrorEnum } from "src/app/main/services/reporting/contract/reporting-contract";
import { ReportingJobService } from "src/app/main/services/reporting/reporting-job.service";
import { SharedModule } from "../../shared/shared.module";

@Component({
  selector: "app-report-component",
  templateUrl: "./report-component.component.html",
  styleUrls: ["./report-component.component.scss"],
  imports: [SharedModule, CdkNoDataRow],
})
export class ReportComponentComponent implements OnInit {
  loading = true;
  notFoundError = false;
  expiredError = false;

  constructor(
    private route: ActivatedRoute,
    private reportingJobService: ReportingJobService,
  ) {}

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get("token");

    if (!token) {
      this.loading = false;
      this.notFoundError = true;
      return;
    }
    await this._fetchReport(token);
  }

  private async _fetchReport(token: string): Promise<void> {
    this.loading = true;

    try {
      const data = await this.reportingJobService.getReportAccess(token);

      this.loading = false;

      if (data.success && data.message) {
        //  Automatically open PDF in a new tab
        window.location.href = data.message;
      } else {
        // Handle case where token has expired
        this.expiredError = data.message === ReportTokenErrorEnum.Expired;
      }
    } catch (error) {
      this.loading = false;
    }
  }
}
